/**
 * record user has visited the website.
 */
export const setVisited = (): void => {
  if (!localStorage.getItem('visited')) {
    localStorage.setItem('visited', '1')
  }
}

/**
 * Checks if the user has visited the site before.
 *
 * This function determines if the user has visited the site by checking if the
 * document referrer contains "msport.com" or if there is a "visited" item in
 * the local storage.
 *
 * @returns {boolean} True if the user has visited the site before, otherwise false.
 */
export const checkVisited = (): boolean => {
  return /msport\.com/.test(document.referrer) || !!localStorage.getItem('visited') || /visited/.test(location.search)
}
